import * as React from 'react';
import PropTypes from "prop-types"

const InHomeSchedulingButtons = (props) => {
    const disabled = !!props?.disabledNext;
    return (
        <div className="buttons-wrapper">
            <div className="subtext">
                <div className="err-holder">
                    {props.showWarning && <div className="err">{props.warningText}</div>}
                </div>
                {props.children}
            </div>
            <div className="buttons">
                <button onClick={props.leftOnClick} className="btn btn-primary">{props.leftBtnLabel}</button>
                <button onClick={props.rightOnClick} disabled={disabled} className="btn btn-primary">{props.rightBtnLabel}</button>
            </div>
        </div>
    )
}

InHomeSchedulingButtons.defaultProps = {
    leftBtnLabel: "PREVIOUS",
    rightBtnLabel: "NEXT",
    showWarning: false,
    warningText: "Please make a selection."
}

InHomeSchedulingButtons.propTypes = {
    leftBtnLabel: PropTypes.string,
    rightBtnLabel: PropTypes.string,
    leftOnClick: PropTypes.func,
    rightOnClick: PropTypes.func,
    showWarning: PropTypes.bool,
    warningText: PropTypes.string,
}

export default InHomeSchedulingButtons